import { Box, Button, Stack, Typography } from "@mui/material";
import type { ReactNode } from "react";
import { Link as RouterLink } from "react-router-dom";

export type StateAction =
  | { label: string; to: string; onClick?: never }
  | { label: string; onClick: () => void; to?: never };

/**
 * Empty state: one quiet icon, a short title, one line of help and at most one
 * action. Centred in the column; never a big illustration.
 */
export function EmptyState({
  icon,
  title,
  body,
  action,
}: {
  icon?: ReactNode;
  title: string;
  body?: ReactNode;
  action?: StateAction;
}) {
  return (
    <Stack
      role="status"
      data-testid="empty-state"
      spacing={0.5}
      sx={{ alignItems: "center", textAlign: "center", px: 2.5, py: 1.5 }}
    >
      {icon ? (
        <Box aria-hidden sx={{ display: "flex", color: "text.secondary", "& svg": { fontSize: 34 } }}>
          {icon}
        </Box>
      ) : null}
      <Typography sx={{ fontSize: "0.9375rem", fontWeight: 600 }}>{title}</Typography>
      {body ? (
        <Typography variant="body2" color="text.secondary">
          {body}
        </Typography>
      ) : null}
      {action ? (
        action.to ? (
          <Button component={RouterLink} to={action.to} variant="contained" size="small" sx={{ mt: 1, minWidth: 136 }}>
            {action.label}
          </Button>
        ) : (
          <Button type="button" onClick={action.onClick} variant="contained" size="small" sx={{ mt: 1, minWidth: 136 }}>
            {action.label}
          </Button>
        )
      ) : null}
    </Stack>
  );
}
